import React, { Suspense } from "react";
import { useLoaderData } from "react-router";

const LazyComponent = ({ component: Component, ...props }) => {
  let loaderData = {};

  try {
    loaderData = useLoaderData();
  } catch (error) {
    console.error(error);
  }

  return (
    <Suspense fallback={null}>
      <Component {...props} {...loaderData} />
    </Suspense>
  );
};

export default LazyComponent;
